import defaultBg from "../assets/backgrounds/chat-background.jpg";
import auroraBg from "../assets/backgrounds/aurora.avif";
import mistyForestBg from "../assets/backgrounds/misty-forest.avif";
import oldTechBg from "../assets/backgrounds/old-tech.avif";
import mountainsBg from "../assets/backgrounds/mountains.avif";
import sunsetBg from "../assets/backgrounds/sunset.avif";
import { checkUserIsRoyal, checkUserIsVIPOrRoyal } from "./checkSubscription";

const currentDate = new Date();
const month = currentDate.getMonth(); // 0 = Jan, 3 = April
const date = currentDate.getDate();
const hour = currentDate.getHours();

// Check if April 27 is a Sunday
const isApril27Sunday = new Date(currentDate.getFullYear(), 3, 27).getDay() === 0;
const isKingsDayOrNight = (
  month === 3 && (
    // April 27 if it's not a Sunday (normal King's Day)
    (date === 27 && !isApril27Sunday) ||
    // April 26 when April 27 is a Sunday (King's Day moved to 26)
    (date === 26 && isApril27Sunday) ||
    // April 25 after 17:00 when King's Day is April 26 (King's Night)
    (date === 25 && isApril27Sunday && hour >= 17) ||
    // April 26 after 17:00 when April 27 is King's Day (King's Night)
    (date === 26 && !isApril27Sunday && hour >= 17)
  )
);

let activeColor = isKingsDayOrNight ? "#f2922c" : "#177FBF";
let secondaryColor = "white";

export const getActiveColor = () => {
  return activeColor;
};

export const setActiveColor = (newColor: string) => {
  activeColor = newColor;
  return activeColor;
};

export const getSecondaryColor = () => {
  return secondaryColor;
};

export const setSecondaryColor = (newColor: string) => {
  secondaryColor = newColor;
  return secondaryColor;
};

export const getBackgroundImage = (image: string, role: string) => {
  const isVip = checkUserIsVIPOrRoyal(role);
  const isRoyal = checkUserIsRoyal(role);

  const getImage = (type: string) => {
    switch (type) {
      case "default":
        return defaultBg;
      case "aurora":
        return auroraBg;
      case "forest":
        return mistyForestBg;
      case "old-tech":
        return oldTechBg;
      case "mountains":
        return mountainsBg;
      case "sunset":
        return sunsetBg;
      default:
        if (isRoyal) {
          return type;
        }
        return defaultBg;
    }
  }

  if (isVip) {
    return `url(${getImage(image)})`;
  }

  return `url(${getImage("default")})`;
};